<template>
<b-container>
<b-card v-if="isInRole('canViewWardUsers')">
  <b-breadcrumb>
    <b-breadcrumb-item :to="{name: 'ward-list', params: { wardId: wardId}}">Back to {{wardInfo.ward_name}}</b-breadcrumb-item>
    <b-breadcrumb-item active>Users</b-breadcrumb-item>
  </b-breadcrumb>
  <h1 class="mb-3">{{wardInfo.ward_name}} Users</h1>
  <b-button class="mb-3"
            v-if="isInRole('canCreateWardUsers')"
            :to="{name:'ward-user-detail', params: { username: null}}"
            variant="primary"> Create User <font-awesome-icon icon="plus" /></b-button>
        <b-row class="mb-3 mt-3">
            <b-col>
                  <b-input-group>
      <b-input-group-prepend is-text>
        <font-awesome-icon :icon="['fa', 'search']"/>
      </b-input-group-prepend>
                <b-input v-model="searchTerm" placeholder="Search for Users" @input="delaySearchUsers"></b-input>
                  </b-input-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-table
                    :fields="table.fields"
                    :items="table.items"
                    :busy="table.isBusy"
                    class="mb-3"
                    show-empty
                    responsive
                    empty-text="No Users to show"
                    :tbody-tr-class="rowClass"
                    outlined>
                    <template v-slot:cell(edit)="row">
                        <b-button
                          v-if="isInRole('canModifyWardUsers')"
                          :key="row.item.uid"
                          :to="{name: 'ward-user-detail', params: { userName: row.item.username}}"  variant="outline-secondary">
                        <font-awesome-icon icon="edit" />
                        </b-button>
                    </template>
                    <template #table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                    </template>
                        <template #cell(last_login)="row">
                            <span :id="'tooltip-updated-' + row.index" v-if="row.item.last_login!==null">{{$moment.utc(row.item.last_login).local().fromNow()}}</span>
                            <b-tooltip :target="'tooltip-updated-' + row.index" triggers="hover" v-if="row.item.last_login!==null">
                                {{$moment.utc(row.item.last_login).local().format('llll')}}
                            </b-tooltip>
                        </template>
                </b-table>
            </b-col>
        </b-row>
        <b-row>
            <b-col align="center">
        <b-button-group v-if="pages.length>1">
            <b-button @click="searchUsers(currentPage-1)">Prev</b-button>
            <b-button @click="searchUsers(currentPage+1)">Next</b-button>
        </b-button-group>
            </b-col>
        </b-row>
</b-card>
</b-container>
</template>canListUsers
<script>
import { UserApi } from "@/api/userApi";
import { WardApi } from "@/app/wards/wardApi";
import { userMixin } from "@/mixins/userMixin";
import handleError from "@/errorHandler";
import {isUserInRole} from "../../oidc/roleRestricted.directive";
import _ from "lodash";

export default {
    name: "WardUserList",
    props: {
        wardId: {
            type: String,
            required: true,
            default: null
        }
    },
    mixins: [userMixin],
    data () {
        return {
            searchTerm: null,
            currentPage: 0,
            lastPage: 0,
            nextPage : {
                aux_id : null,
                pk_id : null,
                gsi_pk: null,
                gsi_sk: null,
            },
            paging: {
                currentPage: 0,
                lastPage:0,
                nextPage:0,
                searchTerm:null
            },
            pages: [],
            table: {
                id:"user-list",
                fields: [,
                    {
                        key: "username",
                        label: "Username"
                    },
                    {
                        key: "full_name",
                        label: "Full Name"
                    },
                    {
                        key: "email",
                        label: "E-Mail"
                    },
                  {
                    key: "last_login",
                    label: "Last Logged In"
                  },
                    {
                        key: "edit",
                        label: "Edit"
                    }

                ],
                items: [],
                isBusy: false
            },
          wardInfo: {
              stake_id: null
          }
        }
    },
    async mounted() {
        this.show = true;
        await this.getWardInfo();
        this.pages.push(this.nextPage);
        await this.searchUsers(0);
        this.show = false;

    },
    methods: {
      isUserInRole,
        async getWardInfo() {
          try {
            const { data } = await WardApi.getWard(this.wardId);
            this.wardInfo = data.ward;
          } catch (e) {
            const msg = "Error searching for users";
            handleError(e, msg);
          } finally {
              this.table.isBusy = false;
          }

        },
        async searchUsers(page) {
            if(page < 0){
                return ;
            }
            if (page > this.pages.length - 1)
            {
                return;
            }
            const payload = this.pages[page];
            payload.search_term = this.searchTerm;
            payload.ward_id = this.wardId;
            payload.stake_id = this.wardInfo.stake_id;
            this.table.isBusy = true;
            try{
                const { data } = await UserApi.getUserList(payload);
                //console.log(data);
                if(data.last_evaluated_key !== null){
                    if(!this.existInPageList(data.last_evaluated_key, this.pages))
                        this.pages.push(data.last_evaluated_key);
                }
                this.table.items = data.result;
                this.currentPage = page;
            } catch (e) {
                const msg = "Error searching for users";
                handleError(e, msg);
            } finally {
                this.table.isBusy = false;
            }
        },
      delaySearchUsers:_.debounce(async function() {
        await this.searchUsers(0);
      }, 500),
        async filterUsers() {
            this.pages = [];
            this.currentPage = 0;
            this.lastPage = 0;
            this.pages.push(this.nextPage);
            await this.searchUsers(0);
        },
        existInPageList(obj, list) {
            if(list.length==0) return false;
            var i;
            for (i = 0; i < list.length; i++) {
                if (list[i].pk_id === obj.pk_id && list[i].aux_id === obj.aux_id) {
                    return true;
                }
            }
            return false;

        },
        rowClass(item, type) {
            if (!item || type !== 'row') return;
            if (item.disabled) return 'contact-disabled';
        }
    },


}
</script>
<style lang="scss">
.contact-disabled {
  color: #757575;
  background-color: #f5f5f5 !important;
}
</style>
